import React, { useContext, useState } from 'react'
import { observer } from 'mobx-react-lite'
import { DraftContext } from '../../../../../../contexts/DraftContext'
import ActionInfluencerItem from './ActionInfluencerItem'

const PAGE_SIZE = 5

export default observer(function InfluencersList() {
  const { influencers, actions } = useContext(DraftContext)
  const [visibleCount, setVisibleCount] = useState(PAGE_SIZE)

  return (
    <div className="pb-8">
      <div className="flex justify-between items-center mb-3">
        <h3 className="font-bold dark:text-white">Campaign actions</h3>
        <span className="text-rb-mat-grey dark:text-rb-dark-mode-text-grey">{actions.length}</span>
      </div>

      {influencers.slice(0, visibleCount).map(inf => <ActionInfluencerItem key={inf.id} influencer={inf} />)}

      {visibleCount < influencers.length && (
        <button
          className="w-full py-2 text-sm font-medium rounded-lg border-1 border-rb-widget-border dark:border-rb-dark-mode-lighter dark:text-white hover:bg-gray-50 dark:hover:bg-rb-dark-mode-lighter"
          onClick={() => setVisibleCount(count => count + PAGE_SIZE)}
        >
          Show more
        </button>
      )}
    </div>
  )
})
